(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const toast = document.querySelector(
      ".shopify-section--willcommen-cta .toast-message",
    );
    if (!toast) return;

    const delayTime =
      parseInt(toast.getAttribute("data-toast-delay"), 10) * 1000;

    const showToastNotification = () => {
      setTimeout(() => {
        toast.classList.add("show");

        setTimeout(() => {
          toast.classList.remove("show");
        }, 4000);
      }, delayTime);
    };

    if (window.Shopify && window.Shopify.designMode) {
      showToastNotification();
    }

    window.addEventListener("klaviyo:reactivated", () => {
      showToastNotification();
    });
  });
})();
